var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1006",
    d: "M13.25 4V4C14.2165 4 15 4.7835 15 5.75V24C15 25.1046 14.1046 26 13 26H3C1.89543 26 1 25.1046 1 24V5.75C1 4.7835 1.7835 4 2.75 4V4",
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1017",
    d: "M17 8H23C24.1046 8 25 8.89543 25 10V20C25 21.1046 24.1046 22 23 22H17",
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1016",
    x: 4,
    y: 10,
    width: 8,
    height: 2,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 434"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1007",
    x: 3,
    y: 14,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1010",
    x: 3,
    y: 17.8242,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1013",
    x: 3,
    y: 21.6484,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1008",
    x: 6.96094,
    y: 14,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1011",
    x: 6.96094,
    y: 17.8242,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1014",
    x: 6.96094,
    y: 21.6484,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1009",
    x: 10.9209,
    y: 14,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1012",
    x: 10.9209,
    y: 17.8242,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1015",
    x: 10.9209,
    y: 21.6484,
    width: 1.7755,
    height: 1.7755,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M3.62891 1L4.12233 0.435169C3.90079 0.241634 3.58655 0.195485 3.31872 0.31715C3.05088 0.438815 2.87891 0.705827 2.87891 1L3.62891 1ZM5.06781 2.25699L4.57438 2.82182C4.85701 3.06871 5.27861 3.06871 5.56123 2.82182L5.06781 2.25699ZM6.50671 1L7.00013 0.435169C6.71751 0.188277 6.29591 0.188277 6.01328 0.435169L6.50671 1ZM7.94561 2.25699L7.45218 2.82182C7.73481 3.06871 8.15641 3.06871 8.43903 2.82182L7.94561 2.25699ZM9.38451 1L9.87793 0.435169C9.59531 0.188277 9.1737 0.188277 8.89108 0.435169L9.38451 1ZM10.8234 2.25699L10.33 2.82182C10.6126 3.06871 11.0342 3.06871 11.3168 2.82182L10.8234 2.25699ZM12.2623 1H13.0123C13.0123 0.705827 12.8403 0.438815 12.5725 0.31715C12.3047 0.195485 11.9904 0.241634 11.7689 0.435169L12.2623 1ZM11.5123 7.31241C11.5123 7.72662 11.8481 8.06241 12.2623 8.06241C12.6765 8.06241 13.0123 7.72662 13.0123 7.31241H11.5123ZM4.37891 7.31241V1H2.87891V7.31241H4.37891ZM3.13548 1.56483L4.57438 2.82182L5.56123 1.69216L4.12233 0.435169L3.13548 1.56483ZM5.56123 2.82182L7.00013 1.56483L6.01328 0.435169L4.57438 1.69216L5.56123 2.82182ZM6.01328 1.56483L7.45218 2.82182L8.43903 1.69216L7.00013 0.435169L6.01328 1.56483ZM8.43903 2.82182L9.87793 1.56483L8.89108 0.435169L7.45218 1.69216L8.43903 2.82182ZM8.89108 1.56483L10.33 2.82182L11.3168 1.69216L9.87793 0.435169L8.89108 1.56483ZM11.3168 2.82182L12.7557 1.56483L11.7689 0.435169L10.33 1.69216L11.3168 2.82182ZM11.5123 1V7.31241H13.0123V1H11.5123Z",
    fill: "#566376"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    x1: 2.75,
    y1: 7.48828,
    x2: 13.3042,
    y2: 7.48828,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M22 9L22 22",
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 4",
    x1: 18.75,
    y1: 15.75,
    x2: 18.75,
    y2: 19.25,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 18.75,
    y1: 10.25,
    x2: 18.75,
    y2: 13.75,
    stroke: "#566376",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCsv);
export default __webpack_public_path__ + "static/media/upload-csv.c9d2d9ccb460082ea6c7d203b1f987d8.svg";
export { ForwardRef as ReactComponent };